import { render, staticRenderFns } from "./NavigationDrawer.vue?vue&type=template&id=3171b9c2&scoped=true"
import script from "./NavigationDrawer.vue?vue&type=script&lang=js"
export * from "./NavigationDrawer.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawer.vue?vue&type=style&index=0&id=3171b9c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3171b9c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3171b9c2')) {
      api.createRecord('3171b9c2', component.options)
    } else {
      api.reload('3171b9c2', component.options)
    }
    module.hot.accept("./NavigationDrawer.vue?vue&type=template&id=3171b9c2&scoped=true", function () {
      api.rerender('3171b9c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/NavigationDrawer.vue"
export default component.exports